import { template as template_3f17e9548999432e8ae4c2fce9b7e3e7 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
export default class UploadFileDeviceConfig extends Component {
    @service
    store;
    @service
    intl;
    static{
        template_3f17e9548999432e8ae4c2fce9b7e3e7(`
    <div class="row form-row">
      <div class="col-6">
        <@form.element
          @label={{t "plant.task.daysToStore"}}
          @property="daysToStore"
          @controlType="number"
          class="days-to-store"
        as |el|>
          <el.control min={{1}} />
        </@form.element>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
